import { render, staticRenderFns } from "./GiftCardTicketBoxTicket.vue?vue&type=template&id=1605334c&"
import script from "./GiftCardTicketBoxTicket.vue?vue&type=script&lang=js&"
export * from "./GiftCardTicketBoxTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports